"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

/**
 * @ignore - do not document.
 */
var _default = _styles.ThemeProvider;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/styles/MuiThemeProvider.js
// module id = 401
// module chunks = 0